import { Component, ViewChild } from '@angular/core';
import {ActionsSubject, select, Store} from '@ngrx/store';

import {FormBuilder, Validators} from '@angular/forms';
import {
    ChacrasGetFactorPRequestAction, ChacrasGetLSRequestAction,
    ChacrasGetSuelosRequestAction
} from 'src/app/features/store/entities/shared/chacras/chacras.actions';
import {
    Chacra,
    Empresa, getChacraNombreNro, MecanicaDeApoyo, MECANICAS,
    Padron,
    PadronListComponent,
    SueloCore,
    SuelosCoreFormInput
} from 'src/app/chacra-core';
import { selectAllEmpresas } from 'src/app/features/store/entities/shared/empresas/empresas.selectors';
import {ContainerFormMapBaseComponent, formatNumber, MapService} from 'src/app/shared';
import {
    selectChacraById,
    selectChacrasChangePendiente
} from 'src/app/features/store/entities/shared/chacras/chacras.selectors';
import {PENDIENTES_LAYER, ZONAS_LAYER} from "../../../../map/constants/layers";
import {Subscription} from "rxjs";
import {ofType} from "@ngrx/effects";
import * as chacrasActions from "../../../../store/entities/shared/chacras/chacras.actions";
import {map} from "rxjs/operators";
import {AppState} from "../../../../../core/store/core.state";
import {LocalStorageService} from "../../../../../core/services";
import {selectAllSuelos} from "../../../../store/entities/shared/suelos/suelos.selectors";


@Component({
    selector: 'app-chacra-form',
    templateUrl: './chacra-form.component.html',
    styleUrls: ['./chacra-form.component.scss']
})
export class ChacraFormComponent extends ContainerFormMapBaseComponent {
    @ViewChild(PadronListComponent, { static: false }) padronesComp;

    _item: Chacra;
    panelPadronesOpenState = false;
    panelSuelosOpenState = false;
    empresas: Empresa[] = [];
    suelos: SueloCore[] = [];
    
    sueloFormInput: SuelosCoreFormInput = null;
    showAddSuelo = false;
    pendienteIngresoManual = false;
    chacraTerrazas = false;
    mecanicas: MecanicaDeApoyo[] = MECANICAS;
    chacraMecanicaApoyoCoberturaVisible = false;
    private subAplicaPractica: Subscription;
    private subMecanicaDeApoyoId: Subscription;

    form = this.fb.group({
        chacraNombre: [{
            value: null,
            readonly: this.readonly
        }, [Validators.required]],
        chacraArea: [null,],
        padrones: [[], null],
        chacraSueloAsignadoId: [null, null],

        chacraFactorLSGeometriaAsignado: { value: null },
        chacraPendienteAsignado: [{ value: null, disabled: true }, [Validators.min(0), Validators.max(100)]],
        chacraLargoAsignado: { value: null },
        
        chacraTerrazas: [false],
        chacraTerrazasLargo: [0],
        chacraTerrazasConstruidas: [false],
        
        aplicaPractica: [false],
        chacraFactorP: [null],
        mecanicaDeApoyoId: [null],
        chacraMecanicaApoyoCobertura: [null]
    });

    constructor(
        protected fb: FormBuilder,
        protected store: Store<AppState>,
        protected localStorageService: LocalStorageService,
        protected mapService: MapService,
        protected actionsSubj: ActionsSubject) {
        super(fb, store, localStorageService, mapService);
    }

        ngOnInit(): void {
        
        super.ngOnInit();

        this.subscriptions.push(
            this.store.pipe(select(selectAllEmpresas))
                .subscribe(empresas => { this.empresas = empresas; })
        );
        this.subscriptions.push(
            this.store.pipe(select(selectAllSuelos))
                .subscribe(suelos => { this.suelos = suelos; })
        );

        this.subscriptions.push(
            this.store.pipe(select(selectChacrasChangePendiente))
                .subscribe(item => {
                    if (item) {
                        if(this.item.chacraFactorLSGeometriaAsignado !== item.chacraFactorLSGeometriaAsignado){
                            this.form.patchValue({
                                chacraFactorLSGeometriaAsignado: item.chacraFactorLSGeometriaAsignado
                            });

                            const chacraPendienteAsignado = this.form.get('chacraPendienteAsignado');
                            chacraPendienteAsignado.enable();
                            chacraPendienteAsignado.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);

                            this.mapService.jsonToPolyline(item.chacraFactorLSGeometriaAsignado, false).subscribe(poliline => {
                                this.mapService.geodesicLenght(poliline).subscribe(
                                    length => {
                                        this.form.patchValue({
                                            chacraLargoAsignado: Math.round(length),
                                        });
                                    }
                                );
                            });

                            this.formChange = true;
                        }
                    }
                })
        );

        this.subscriptions.push(
            this.store.pipe(select(selectChacraById(this.item.chacraId)))
                .subscribe(item => {
                    if (item) {
                        this.item = item;
                    }
                })
        );

        this.subscriptions.push(
            this.actionsSubj.pipe(
                ofType(chacrasActions.ChacrasActionTypes.CHACRAS_GET_FACTOR_P_SUCCESS),
                map((action: chacrasActions.ChacrasGetFactorPSuccessAction) => action.payload.factorP),
            ).subscribe(factorP => {
                this.form.patchValue({
                    chacraFactorP: factorP
                });
            })
        );

        this.subscriptions.push(
            this.actionsSubj.pipe(
                ofType(chacrasActions.ChacrasActionTypes.CHACRAS_CHANGE_PENDIENTE),
                map((action: chacrasActions.ChacrasChangePendienteAction) => action.payload.item),
            ).subscribe(chacra => {
                this.pendienteIngresoManual = true;
            })
        );
        
        this.setFormLogic();
    }

    setItem() {
        this.form.patchValue({
            chacraNombre: this.item.chacraNombre,
            chacraArea: Math.round(this.item.chacraArea),
            chacraPendienteAsignado: this.item.chacraPendienteAsignado ? Math.round(this.item.chacraPendienteAsignado*100) : this.item.chacraPendienteAsignado,
            chacraLargoAsignado: this.item.chacraLargoAsignado,
            chacraFactorLSGeometriaAsignado: this.item.chacraFactorLSGeometriaAsignado,
            padrones: this.item.padrones,
            chacraSueloAsignadoId: this.item.chacraSueloAsignadoId,
            chacraTerrazas: this.item.chacraTerrazasLargo > 0,
            chacraTerrazasLargo: this.item.chacraTerrazasLargo,
            chacraTerrazasConstruidas: this.item.chacraTerrazasConstruidas,
            aplicaPractica: this.item.mecanicaDeApoyoId > 0 || this.item.mecanicaDeApoyoId != '0',
            mecanicaDeApoyoId: this.item.mecanicaDeApoyoId,
            chacraMecanicaApoyoCobertura: this.item.chacraMecanicaApoyoCobertura,
            chacraFactorP: this.item.chacraFactorP
        });
        
        this.chacraTerrazas = this.item.chacraTerrazasLargo > 0;
        
        this.sueloFormInput = {
            suelos: this.suelos,
            chacra: this.item,
        };

        this.changeValuesCalcFactorP();
    }

    setFormLogic() {
        // terrazas
        this.form.get('chacraTerrazas').valueChanges.subscribe(chacraTerrazas => {
            this.chacraTerrazas = chacraTerrazas;
            if (chacraTerrazas) {
                this.form.get('chacraTerrazasLargo').setValidators([
                    Validators.required,
                    Validators.min(1)
                ]);
            } else {
                this.form.get('chacraTerrazasLargo').setValidators([]);
                this.form.patchValue({
                    chacraTerrazasLargo: 0,
                    chacraTerrazasConstruidas: false
                });
            }
        });
    }

    getTitle(): string {
        let title = 'Chacra';
        if (this.item) {
            title = getChacraNombreNro(this.item);
        }
        return `${title}${super.getTitle()}`;
    }

    getValues() {
        
        const aplicaPractica = this.form.getRawValue().aplicaPractica;
        const value: Chacra = {
            ...this.item,
            chacraNombre: this.form.value.chacraNombre,
            padrones: this.selectedPadrones(),
            chacraTerrazas: this.form.value.chacraTerrazas,
            chacraTerrazasLargo: this.form.value.chacraTerrazasLargo,
            chacraTerrazasConstruidas: this.form.value.chacraTerrazasConstruidas,
            aplicaPractica: aplicaPractica,
            mecanicaDeApoyoId: aplicaPractica ? this.form.getRawValue().mecanicaDeApoyoId : '0',
            chacraMecanicaApoyoCobertura: this.form.getRawValue().chacraMecanicaApoyoCobertura,
            chacraFactorP: this.form.getRawValue().chacraFactorP
        };

        if (this.form.value.chacraSueloAsignadoId !== this.item.chacraSueloAsignadoId) {
            const s = this.item.suelos.find(ss => ss.sueloId === this.form.value.chacraSueloAsignadoId);
            if (s) {
                value.chacraSueloAsignadoId = s.sueloId;
                value.chacraSueloAsignadoDsc = s.sueloDesc;
                value.chacraSueloAsignadoFactorK = s.sueloFactorK;
                value.chacraSueloAsignadoSlopeMin = s.sueloSlopeMin;
                value.chacraSueloAsignadoSlopeMax = s.sueloSlopeMax;
                value.chacraSueloAsignadoTolerancia = s.sueloTolerancia;
            }
        }
        
        if (this.pendienteIngresoManual) {
            value.chacraFactorLSEsManual = this.pendienteIngresoManual;
            value.chacraFactorLSGeometriaAsignado = this.form.value.chacraFactorLSGeometriaAsignado;
            value.chacraPendienteAsignado = this.form.value.chacraPendienteAsignado ? this.form.value.chacraPendienteAsignado/100 : this.form.value.chacraPendienteAsignado;
            value.chacraLargoAsignado = this.form.value.chacraLargoAsignado;
        } else {
            if(!value.chacraFactorLSEsManual)
                value.chacraFactorLSGeometriaAsignado = value.chacraFactorLSGeometriaLimitante;
        }

        this.pendienteIngresoManual = false;

        return { ...value };
    }

    submit(item: Chacra) {
    }

    selectedPadrones() {
        return this.form.value.padrones.map(p => {
            return {
                ...p,
                padronFueSeleccionado: true
            };
        });
    }

    onAddPadron(event: any) {
        event.stopPropagation();
        this.padronesComp.newPadron();
    }

    padronesChange(padrones: Padron[]) {
        this.form.patchValue({
            padrones: padrones
        });
        this.formChange = true;
    }

    onPendienteManual() {
        this.drawEvent.emit({layer: PENDIENTES_LAYER.name});
    }

    onAddZonaExclusion() {
        this.drawEvent.emit({layer: ZONAS_LAYER.name});
    }

    formatFormulaVal(num){
        return formatNumber(num);
    }

    addSuelo(suelo: SueloCore){
        this.item.suelos = Object.assign([], this.item.suelos);
        this.item.suelos.push({...suelo});
        this.form.patchValue({
            chacraSueloAsignadoId: suelo.sueloId
        });
        this.form.markAsDirty();
        this.showAddSuelo = false;
    }

    getSuelos() {
        const payload = {item: this.item, loading: true};
        this.store.dispatch(new ChacrasGetSuelosRequestAction(payload));
    }

    calcularPendiente(){
        const payload = {item: this.item, loading: true};
        this.store.dispatch(new ChacrasGetLSRequestAction(payload));
        this.formChange = true;
    }

    emitChangeCalcFactorP() {
        const payload = {item: this.getValues()};
        this.store.dispatch(new ChacrasGetFactorPRequestAction(payload));
    }
    
    /** Cuando cambia algun factor que recalcula el factor p */
    changeValuesCalcFactorP() {
        if (this.subAplicaPractica) {
            this.subAplicaPractica.unsubscribe();
        }
        if (this.subMecanicaDeApoyoId) {
            this.subMecanicaDeApoyoId.unsubscribe();
        }
        
        this.chacraFactorPEnable(false);
        this.chacraMecanicaApoyoCoberturaSetEnable(false);

        const aplicaPractica = this.form.get('aplicaPractica').value;
        switch (this.item.tipoLaboreo) {
            case 'SD':
                this.siembraDirecta(aplicaPractica);
                break;
            case 'LC':
                this.laboreoConvencional(aplicaPractica);
                break;
            case 'MX':
                this.laboreoMixto();
                break;
        }

        this.subAplicaPractica = this.form.get('aplicaPractica').valueChanges.subscribe(_ => {
            this.changeValuesCalcFactorP();
        });

        this.subMecanicaDeApoyoId = this.form.get('mecanicaDeApoyoId').valueChanges.subscribe(_ => {
            this.changeValuesCalcFactorP();
        });
    }

    /**
     * Se declara "Siembra Directa" en toda la rotación
     */
    siembraDirecta(aplicaPractica: boolean) {
        this.chacraMecanicaApoyoCoberturaSetEnable(false);
        let mecanicasIds = [4];
        if (this.form.get('chacraTerrazas').value) {
            mecanicasIds = [4, 6];
        }
        this.mecanicas = MECANICAS.filter(m => mecanicasIds.includes(m.mecanicaId));

        if (aplicaPractica) {
            this.mecanicaDeApoyoEnable(true);
            this.emitChangeCalcFactorP();

            const mecanicaDeApoyoIdValue = this.form.get('mecanicaDeApoyoId').value;
            if (mecanicaDeApoyoIdValue === 4) {
                this.chacraFactorPEnable(true, '0.9');
            }

            if (mecanicaDeApoyoIdValue === 6) {
                this.chacraFactorPEnable(false, '1');
            }

        } else {
            this.mecanicaDeApoyoEnable(false);
            this.chacraFactorPEnable(false, '1');
        }
    }

    /**
     * Se declara "laboreo convencional" en toda la rotación
     */
    laboreoConvencional(aplicaPractica: boolean) {
        this.chacraFactorPEnable(false);
        this.mecanicas = MECANICAS.filter(m => [4, 5].includes(m.mecanicaId));

        if (aplicaPractica) {
            this.mecanicaDeApoyoEnable(true);

            const mecanicaDeApoyoIdValue = this.form.get('mecanicaDeApoyoId').value;
            // 'Cultivo en fajas'
            if (mecanicaDeApoyoIdValue === 5) {
                this.chacraMecanicaApoyoCoberturaSetEnable(true);
            }

            this.emitChangeCalcFactorP();

        } else {
            this.mecanicaDeApoyoEnable(false);
            this.chacraMecanicaApoyoCoberturaSetEnable(false);
            this.chacraFactorPEnable(false, '1');
        }
    }

    /**
     * Se declara "Mixta", parte siembra directa y parte laboreo convencional
     */
    laboreoMixto() {
        this.chacraFactorPEnable(false);
        this.aplicaPracticaEnable(true);
        this.mecanicas = MECANICAS.filter(m => [4, 5].includes(m.mecanicaId));
        this.form.patchValue({
            aplicaPractica: true
        });
        this.mecanicaDeApoyoEnable(true);

        const mecanicaDeApoyoIdValue = this.form.get('mecanicaDeApoyoId').value;
        // 'Cultivo en fajas'
        if (mecanicaDeApoyoIdValue === 5) {
            this.chacraMecanicaApoyoCoberturaSetEnable(true);
        }
        this.emitChangeCalcFactorP();
    }

    chacraFactorPEnable(enable: boolean, defaultValue: string = null) {
        const chacraFactorP = this.form.get('chacraFactorP');

        if (enable) {
            chacraFactorP.enable();
            // Se asume que en el unico momento que el usuario inserta el factor p debe estar en ese rango
            chacraFactorP.setValidators([Validators.required, Validators.min(0.9), Validators.max(1)]);
        } else {
            chacraFactorP.disable();
            chacraFactorP.setValidators(null);
        }
        if (defaultValue) {
            this.form.patchValue({
                chacraFactorP: defaultValue
            });
        }
    }

    mecanicaDeApoyoEnable(enable: boolean) {
        const mecanicaDeApoyoId = this.form.get('mecanicaDeApoyoId');
        if (enable) {
            mecanicaDeApoyoId.enable();
            mecanicaDeApoyoId.setValidators([Validators.required]);
        } else {
            mecanicaDeApoyoId.disable();
            mecanicaDeApoyoId.setValidators(null);
        }
    }

    chacraMecanicaApoyoCoberturaSetEnable(enable: boolean) {
        const chacraMecanicaApoyoCobertura = this.form.get('chacraMecanicaApoyoCobertura');
        if (enable) {
            chacraMecanicaApoyoCobertura.enable();
            chacraMecanicaApoyoCobertura.setValidators([Validators.required]);
            this.chacraMecanicaApoyoCoberturaVisible = true;
        } else {
            chacraMecanicaApoyoCobertura.disable();
            chacraMecanicaApoyoCobertura.setValidators(null);
            this.chacraMecanicaApoyoCoberturaVisible = false;
        }

        this.form.patchValue({
            chacraMecanicaApoyoCobertura: this.item.chacraMecanicaApoyoCobertura,
        });
    }

    aplicaPracticaEnable(enable: boolean) {
        const aplicaPractica = this.form.get('aplicaPractica');
        if (enable) {
            aplicaPractica.enable();
            aplicaPractica.setValidators([Validators.required]);
        } else {
            aplicaPractica.disable();
            aplicaPractica.setValidators(null);
        }
    }
}
